import React from "react";
// import {Link} from 'react-router-dom';

function Become() {
  return (
    <>
      <div id="unique" className="container-fluid">
        <div className="row">
          <h2 className="heading">Become a part of Unique Ecosystem</h2>
          <p className="para-sub home_p">
            Earn <b>$LITTLE</b> as a utility token by staking your NFT
            <br /> and get rewarded daily in MATIC
          </p>
        </div>

        <div className="row unique">
          <div className="col-sm-4">
            <div className="price-section">
              <article className="home_price_table">
                <img src={"images/box.png"} alt="earn" className="cards" />
                <h3 className="utilities-head">Earn $LITTLE</h3>
                <p className="little_para home_p">
                  Stake your Little Billionaire NFT in your personal user panel
                  and get daily rewards in $LITTLE tokens credited to your
                  balance.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="home_price_table">
                <img src={"images/3.png"} alt="use-eco" className="cards" />
                <h3 className="utilities-head">Use the Ecosystem</h3>
                <p className="little_para home_p">
                  Benefit from a variety of utilities like Launchpads, Liquidity
                  providing and a Marketplace where $LITTLE is the center of
                  payment.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="home_price_table" style={{ marginLeft: "0" }}>
                <img src={"images/4.png"} alt="earn" className="cards" />
                <h3 className="utilities-head">Earn MATIC</h3>
                <p className="little_para home_p">
                  $LITTLE is based on the
                  <br /> Polygon network. Hold your
                  <br /> $LITTLE tokens and get
                  <br /> MATIC as a reward which you
                  <br /> can withdraw at any time.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Become;
